<div class="users-table__container">
  <table #usersTableEl mat-table class="users-table" [dataSource]="dataSource" [trackBy]="trackByFn">
    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let user; let idx = index">
        <div class="users-table__name">
          <oph-avatar [user]="user" [size]="28"></oph-avatar>
          <span [title]="user.firstName + ' ' + user.lastName">{{ user.firstName }} {{ user.lastName }}</span>
        </div>
      </td>
    </ng-container>

    <!-- Username Column -->
    <ng-container matColumnDef="username">
      <th mat-header-cell *matHeaderCellDef>Username</th>
      <td mat-cell *matCellDef="let user">
        <span>{{ user.username }}</span>
      </td>
    </ng-container>

    <!-- Team Column -->
    <ng-container matColumnDef="team">
      <!-- only one team can be assigned to a user, but it's in an array -->
      <th mat-header-cell *matHeaderCellDef>Team</th>
      <td mat-cell *matCellDef="let user">
        {{ user?.teams?.[0]?.name || 'No team assigned' }}
      </td>
    </ng-container>

    <!-- Role Column -->
    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef>Role</th>
      <!-- only one role can be assigned to a user, but it's in an array -->
      <td mat-cell *matCellDef="let user">
        {{ user?.roles?.[0]?.displayName || 'No role assigned' }}
      </td>
    </ng-container>

    <!-- Lenses Column -->
    <ng-container matColumnDef="lens">
      <th mat-header-cell *matHeaderCellDef>Lens</th>
      <td mat-cell *matCellDef="let user">
        {{ user?.lens?.title || 'No lens assigned' }}
      </td>
    </ng-container>

    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let user">
        <div class="users-table__actions">
          <list-view-menu
            [options]="user | getMenuOptionsByUser: (currentUser$ | async)"
            (action)="onMenu($any($event), user)"
          ></list-view-menu>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let user; columns: displayedColumns" (click)="editUser(user)"></tr>
    <tr *matNoDataRow>
      <td class="users-table__empty" [attr.colspan]="displayedColumns.length">No users match your search criteria.</td>
    </tr>
  </table>

  <div class="users-table__paginator-container">
    @if ((searchValue$() | async) === '') {
      <oph-paginator
        [page]="currentPage + 1"
        [totalPages]="totalPages()"
        (pageChange)="onPageChange($event)"
        [preventRouting]="true"
      />
    }
  </div>
</div>
